import React from 'react';
import MainLayout from '../components/MainLayout';
import { Link } from "react-router-dom";
import Accordion from 'react-bootstrap/Accordion';
import technology from '../assets/images/svg/technology.svg';
import innovation from '../assets/images/svg/innovation.svg';
import dedication from '../assets/images/svg/dedication.svg';
import teamwork from '../assets/images/svg/teamwork.svg';
// import vision1 from '../assets/images/svg/vision1.svg';
// import vision2 from '../assets/images/svg/vision2.svg';
// import mission1 from '../assets/images/svg/mission1.svg';
// import about0 from '../assets/images/about-0.png';
// import about1 from '../assets/images/about-1.png';
import { FaCheck } from "react-icons/fa";

import vision_pic from '../assets/images/vision_pic.png';
import mission_pic from '../assets/images/mission_pic.png';
import whoweare from '../assets/images/img/who-we-are.jpg';

export default function WhoWeAre() {
  return (

    <>
    <MainLayout>

  <div className='breadcrumb_area'>
    <div className='photo'>
    <img src={whoweare} alt=''/>
      <div className='wrapper'> 
          <div className='container'>
          <div className='row'>
          <div className='col-12'>
          <h1 className='breadcrumb_title'>About Us</h1>
          <ul className="breadcrumb_list">
          <li className="breadcrumb_item"><Link to='/'>Home</Link></li>
          <li className="breadcrumb_item">Who We Are</li>                 
          </ul>
          </div>
          </div>
          </div>  
      </div>
    </div>


  </div>


<div className='inner_page_content who_we_are'> 
    <div className='container'>

        <div className='row'>

          <div className='col-12'>
          
          <h2 className='mb-3'>We are passionate in delivering world-class Travel Technology solutions that builds your brand, business and customer relationship</h2>
              
              
        <p>We are one of the few companies that combine extensive domain knowledge with state of the art technology, delivering an array of Information Technology Services and products tailored to the needs of the Travel and technology Industry.</p>      

          <p>Our world-class infrastructure, efficient delivery processes, technical expertise and deep Travel & Tourism and technology domain knowledge helps us offer tremendous cost savings and competitive edge to our clients.</p>


          </div>

        </div>

{/* <div className='row mt-4 mb-4'>

<div className='col-lg-6'>

<div className='aboutImg'>
<img className='img-fluid' src={about0} alt='' />
</div>

</div>

<div className='col-lg-6'>

<div className='aboutImg'>
<img className='img-fluid' src={about1} alt='' />
</div>

</div>

</div> */}

    <div className='row mt-4'>

    <div className='col-lg-10'>

    <div className='accordion_component'>

    <Accordion defaultActiveKey="0">

      <Accordion.Item eventKey="0">
        <Accordion.Header>How can we help your business? </Accordion.Header>
        <Accordion.Body>

          <ol>
          <li>We consistently interact and work together to create intelligent solutions that meet your business demands.</li>
          <li>Our team will work with you to shape your ideas into something even better for your users.</li>
          <li>Benzy infotech allows you to focus on what you need, knowing how we will deliver it. Once you work with us, you won’t want to go back to anything else.</li>
          </ol>  

        </Accordion.Body>
      </Accordion.Item>
    
      <Accordion.Item eventKey="1">
        <Accordion.Header>How working process is simplified?</Accordion.Header>
        <Accordion.Body>

            <ol>
            <li>Our productive workflow makes sure that the business process our company creates for you is efficient and easy enough that you don't have to micromanage it.</li>
            <li>We help clients across the globe to launch next-generation products that have a meaningful impact on the IT industry.</li>
            </ol>  

        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="2">
        <Accordion.Header>Advantages</Accordion.Header>
        <Accordion.Body>

            <ol>
            <li>Transparency, shared values, and focus on the customer’s success lie in the core of our collaboration. We do not just provide innovative tech solutions; we go out of our way to make your product incredible based on a profound market research.</li>
            </ol>  


        </Accordion.Body>
      </Accordion.Item>
    </Accordion>

    </div>


    </div>

    <div className='col-lg-2'>
       <div className='firmWeight'> 
        <h1>17+</h1>
        <p>Years of Experience</p>

            <hr/>
            <h1>100+</h1>
            <p>Consortium of Skilled Professionals</p>
            </div>
      </div>


    </div>


    <div className='row d-none'>
    <div className='col-lg-12 mb-3'> <hr/> </div>
      <div className='col-lg-3 text-center border-end'>
        <div className='firm_expertise'>

          <div className='icon'>
          <div className='holder'>
          <img src={technology} alt='' />
          </div>

          </div>
        
          <div className='title'>TECHNOLOGY</div>

        </div>

      </div>

      <div className='col-lg-3 text-center border-end'>
        <div className='firm_expertise'>

          <div className='icon'>
          <div className='holder'>
          <img src={innovation} alt='' />
          </div>

          </div>
        
          <div className='title'>INNOVATIONS</div>

        </div>

      </div>

      <div className='col-lg-3 text-center border-end'>
        <div className='firm_expertise'>

          <div className='icon'>
          <div className='holder'>
          <img src={dedication} alt='' />
          </div>

          </div>
        
          <div className='title'>DEDICATION</div>

        </div>

      </div>

      <div className='col-lg-3 text-center'>
        <div className='firm_expertise'>

          <div className='icon'>
          <div className='holder'>
          <img src={teamwork} alt='' />
          </div>

          </div>
        
          <div className='title'>TEAMWORK</div>

        </div>

      </div>


      <div className='col-lg-12 mt-3'> <hr/> </div>     
     

    </div>


    <div className='row mt-3'>

    <div className='col-lg-4'>
          <div className='quality_work'>
          <span><FaCheck /> TECHNOLOGY </span>
          </div>
      </div>

      <div className='col-lg-4'>
          <div className='quality_work'>
          <span><FaCheck /> INNOVATIONS </span>
          </div>
      </div>

      <div className='col-lg-4'>
          <div className='quality_work'>
          <span><FaCheck /> DEDICATION </span>
          </div>
      </div>

      <div className='col-lg-4'>
          <div className='quality_work'>
          <span><FaCheck /> TEAMWORK </span>
          </div>
      </div>

      <div className='col-lg-4'>
          <div className='quality_work'>
          <span><FaCheck /> Professional Expertise </span>
          </div>
      </div>

      <div className='col-lg-4'>
          <div className='quality_work'>
          <span><FaCheck /> Quality Services </span>
          </div>
      </div>

      <div className='col-lg-4'>
          <div className='quality_work'>
          <span><FaCheck /> Custom Built Solution </span>
          </div>
      </div>

      <div className='col-lg-4'>
          <div className='quality_work'>
          <span><FaCheck /> Competitive Price </span>
          </div>
      </div>

      <div className='col-lg-4'>
          <div className='quality_work'>
          <span><FaCheck /> Stand Out From Competitiors </span>
          </div>
      </div>

      <div className='col-lg-4'>
          <div className='quality_work'>
          <span><FaCheck /> Customer Satisfaction </span>
          </div>
      </div>

    </div>


  <div className='row mt-5 our_story'>

<div className='col-lg-12 text-center'>
<h2>Our Aim is to Help You Succeed in Your Mission</h2>
  <p className='des'>The future of creativity is a story we're shaping with our clients across all industries & sectors. Join the world's best Server Support with
  SupportFly.</p>
</div>

      <div className='col-lg-4 text-center mt-2'>

        <div className='st'> 
          <h6>Be open-minded</h6>
          <p>Explore, learn and Solution</p>
          </div>
     
      </div>
  

      <div className='col-lg-4 text-center mt-2'>

        <div className='st'> 
          <h6>Be honest</h6>
          <p>Be honest with yourself, your team and your client</p>
          </div>
     
      </div>

      <div className='col-lg-4 text-center mt-2'>

<div className='st'> 
  <h6>Be fulfilled</h6>
  <p>Enjoy and Inspire</p>
  </div>

</div>

<div className='col-lg-4 text-center mt-2'>

<div className='st'> 
  <h6>Be client-oriented</h6>
  <p>Build long-term & reliable relationships with Clients</p>
  </div>

</div>

<div className='col-lg-4 text-center mt-2'>

<div className='st'> 
  <h6>Be focused on results</h6>
  <p>Work and Achieve</p>
  </div>

</div>

<div className='col-lg-4 text-center mt-2'>

<div className='st'> 
  <h6>Put your team first</h6>
  <p>Team results over personal ambitions</p>
  </div>

</div>
    

  </div>


    <div id='vision-mission' className='row'>

    <div className='col-12 mt-5'>

      <div className='vision'>

    
      <div><img src={vision_pic} alt='' /></div>     

        <div>
        <h2>Vision</h2>
        <p>Our vision is to provide end-to-end business solutions that leverage quality for a dynamic environment where our client's business strategy and our technology strategy converge. Offer the best of what we can, for the benefit of technological and business advancements in every job we undertake. To actively improve the technology solutions and the quality of service for a stronger customer value.</p>

        </div>

        {/* <div><img src={vision2} alt='' /></div> */}
       

      </div>

    </div>


    <div className='col-12 mt-5'>

<div className='mission'>

  <div><img src={mission_pic} alt='' /></div>
        

  <div>
  <h2>Mission</h2>
<p>To conceptualize and realize smart and quality driven business transformation intiatives with the help of cutting-edge technologies and efficient resources. We strive for lending a helping hand to customers in need of technological assistance to take their company forward. Also focus on the purpose of the assignment with honesty and integrity.</p>
  </div>


</div>

</div>

    </div>



    </div>
  </div>
    </MainLayout>
    </>


  )
}
